import { ReactNode } from 'react';

// Wraps the part of a label that matches the query in <strong>; returns the plain label when there is no match.
export const highlightMatch = (
  label: string | undefined,
  searchString: string
): ReactNode => {
  const trimmed = searchString.trim();
  if (!trimmed || !label) return label;

  const index = label.toLowerCase().indexOf(trimmed.toLowerCase());
  if (index === -1) return label;

  const before = label.slice(0, index);
  const match = label.slice(index, index + trimmed.length);
  const after = label.slice(index + trimmed.length);

  return (
    <>
      {before}
      <strong style={{ fontWeight: 800 }}>{match}</strong>
      {after}
    </>
  );
};
